<div class="content-body bg-light">
  <div class="main-container container-fluid d-flex flex-column flex-grow-1">
    <div class="remote-client-container container-fluid px-md-5 px-sm-1 mx-sm-0">
      <div class="row">
        <div class="col-12">
          <div class="py-4">
            <div class="row mb-4">
              <div class="col-12">

                <h3 class="mb-3">Environment Name: '{{environmentInfo.environmentName }}'</h3>
                <ng-container >
                  <table class="table table-bordered card-body">
                    <thead >
                      <tr >
                        <th class="font-weight-bold">Name </th>
                        <th class="font-weight-bold">Private IP</th>
                        <th class="font-weight-bold">Public IP</th>
                        <!-- <th class="font-weight-bold">Management Center</th> -->
                      </tr>
                    </thead>
                    <tbody class="code-block">
                      <tr *ngFor="let server of environmentInfo.servers">
                        <td>{{ server.name }}</td>
                        <td>{{ server.privateIp }}</td>
                        <td *ngIf="server.publicIp != null; else dashes" >{{ server.publicIp }}</td>
                        <ng-template #dashes>
                          <td>---</td>
                        </ng-template>
                        <!-- <td>
                          <a [href]="'http://' + server.publicIp + ':8251'" target="_blank"   [class.disabled]="server.publicIp == null">Manage</a>
                        </td> -->
                      </tr>
                    </tbody>
                  </table>
                </ng-container>

                <div *ngIf=" linkType === 'remoteclient' || linkType === 'powershell'">
                  <ul class="nav nav-tabs d-flex">
                    <li class="nav-item">
                      <a class="nav-link active" data-bs-toggle="tab" href="#remoteclientconfiguration"><strong>Remote Client</strong></a>
                    </li>
                    <li class="nav-item">
                      <a class="nav-link" data-bs-toggle="tab" href="#powershellconfiguretion"><strong>PowerShell</strong></a>
                    </li>
                  </ul>
                  <div class="tab-content">
                    <div id="remoteclientconfiguration"  class="card tab-pane show active">
                  <div class="card-body">
                    <h3 >Remote Client Configuration</h3>
                    <p>
                    <span *ngIf="!isApiInProgress">
                      Install the NCache client
                      (<a [href]="getPackageLink('nuget')" target="_blank">NuGet</a>,
                      <a [href]="getPackageLink('maven')"  target="_blank">Maven</a>,
                      <a [href]="getPackageLink('npm')"  target="_blank">npm</a>,
                      <a [href]="getPackageLink('pipy')"  target="_blank">PiPy</a>,
                      <a [href]="getPackageLink('isntaller')"  target="_blank">Installer</a>)
                      on your computer. You can also set up PowerShell for NCache. Then, access the NCache Cloud environment remotely.
                    </span>
                    <br>
                    <span class="d-block mt-2 ">
                       <b>NOTE:</b> The example configuration and code use the cache 'demoCache'. If you've created a different cache, then simply replace the cache name 'demoCache' with your cache name.
                    </span>
                    <span class="d-block mt-2">
                      <b>NOTE:</b> Please make sure to run your remote client in the same Azure region and availability zone for good performance.
                    </span>
                    </p>
                    <h4>Option 1: Through Config File</h4>

                    <p>
                      Use client.ncconf to configure remote cache connections.
                    </p>




                            <div class= "code-block p-3" style="background-color:#F9F9F9 !important;font-size:1.2rem !important " id="configuration-code">
<pre><code><span class="tag">&lt;configuration&gt;</span>
    <span class="tag">&lt;ncache-server</span> <span class="attribute">connection-retries="<span class="value">3</span>"</span> <span class="attribute">retry-connection-delay="<span class="value">0</span>"</span> <span class="attribute">retry-interval="<span class="value">1</span>"</span>
        <span class="attribute">command-retries="<span class="value">3</span>"</span> <span class="attribute">command-retry-interval="<span class="value">0.1</span>"</span> <span class="attribute">client-request-timeout="<span class="value">90</span>"</span>
        <span class="attribute">connection-timeout="<span class="value">5</span>"</span> <span class="attribute">port="<span class="value">9800</span>"</span> <span class="attribute">enable-keep-alive="<span class="value">false</span>"</span> <span class="attribute">keep-alive-interval="<span class="value">30</span>"</span><span class="tag">/&gt;</span>

    <span class="tag">&lt;cache</span> <span class="attribute">id="<span class="value">demoCache</span>"</span> <span class="attribute">client-cache-id="<span class="value"></span>"</span>
        <span class="attribute">skip-client-cache-if-unavailable="<span class="value">true</span>"</span> <span class="attribute">reconnect-client-cache-interval="<span class="value">10</span>"</span>
        <span class="attribute">load-balance="<span class="value">false</span>"</span> <span class="attribute">enable-client-logs="<span class="value">False</span>"</span> <span class="attribute">log-level="<span class="value">error</span>"</span><span class="tag">&gt;</span>

            <ng-container *ngFor="let ip of getServerXmlEntries()"><span class="tag">&lt;server name="<span class="value">{{ ip }}"</span>/&gt;</span>
            </ng-container>
    <span class="tag">&lt;/cache&gt;</span>
<span class="tag">&lt;/configuration&gt;</span></code></pre>
                    </div>
                    <h4>Option 2: Through Code</h4>
                    <p>
                      You can connect to NCache programmatically too...
                    </p>

                    <!-- Tabs Start -->
                        <ul class="nav nav-tabs d-flex bg-light">
                      <li class="nav-item">
                        <a class="nav-link active" data-bs-toggle="tab" href="#dotnet"><strong>.NET</strong></a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" data-bs-toggle="tab" href="#java"><strong>Java</strong></a>
                      </li>
                    </ul>

                    <div class="tab-content border mb-0 pb-0  mt-2 justify-content-between" style="background-color:#F9F9F9 !important;font-size:1.2rem !important">
                      <div class="tab-pane show active" id="dotnet">
                        <div class="code-block" id="dotnet-code">
  <pre><code><span class="code-attribute">CacheConnectionOptions cacheConnectionOptions = </span> <span class="code-keywords">new</span> <span class="code-attribute"> CacheConnectionOptions();</span>
<span class="code-keywords">string </span> <span class="code-attribute">serverIp = </span> <span class="code-value">"{{this.getFirstPublicIp() ?? this.defaultIp}}"</span> <span class="code-attribute">;</span>
<span class="code-attribute">cacheConnectionOptions.ServerList = </span> <span class="code-keywords">new</span> <span class="code-attribute">List&lt;ServerInfo&gt;</span><span class="tag">&#123;</span> <span class="code-keywords">new</span> <span class="code-attribute"> ServerInfo(serverIp)</span><span class="tag">&#125;;</span>
<span class="code-attribute">ICache cache = CacheManager.GetCache(</span><span class="code-value">"demoCache"</span><span class="code-attribute">,cacheConnectionOptions);</span></code></pre>
                        </div>
                      </div>
                      <div class="tab-pane" id="java">
                            <div class="code-block" id="java-code">
<pre><code><span class="code-keywords">String</span> <span class="code-attribute">serverIp = </span><span class="code-value">"{{this.getFirstPublicIp() ?? this.defaultIp}}";</span>
<span class="code-attribute">List&lt;ServerInfo&gt; serverList =</span> <span class="code-keywords">new </span> <span class="code-attribute">ArrayList&lt;ServerInfo&gt;();</span>
<span class="code-attribute">serverList.add(<span class="code-keywords">new</span> ServerInfo(serverIp));</span>
<span class="code-attribute">CacheConnectionOptions cacheConnectionOptions = </span><span class="code-keywords">new</span><span class="code-attribute"> CacheConnectionOptions();</span>
<span class="code-attribute">cacheConnectionOptions.setServerList(serverList);</span>
<span class="code-attribute">Cache cache = CacheManager.getCache(<span class="code-value">"demoCache",</span>cacheConnectionOptions);</span>
</code></pre>
                            </div>
                      </div>


                  </div>
                </div>
                </div>

                <div id="powershellconfiguretion" class="card tab-pane">
                  <div class="card-body">
                    <h4>Connect through PowerShell</h4>
                    <p>
                      Install and use PowerShell to quickly connect with NCache Cloud servers from your workstation/server and see it work. Use it also to get an idea of NCache Cloud performance and the latency from your environment to NCache Cloud servers.
                    </p>
                    <p>
                      To install one of these NCache PowerShell Modules (Run as Administrator):
                    </p>
                    <div class="code-snippet mb-4 ">
                      <code class="xml-style" >
                        <span>Install-Module -Name NCache</span>
                        <br>
                        <span>Install-Module -Name NCache.Professional</span>
                      </code>
                    </div>

                    <p class="my-2">
                      "NCache" module is for the Enterprise edition. Now enable remote execution.
                    </p>

                    <div class="code-snippet mb-4 ">
                      <code class="xml-style" >
                        <span>Set-ExecutionPolicy -ExecutionPolicy RemoteSigned -Scope LocalMachine</span>
                      </code>
                    </div>

                    <p class="my-2">
                      Now, let's verify that you are connected to NCache Cloud servers (do for one or all servers):
                    </p>

                    <div class="code-snippet mb-4 " bg-light>
                      <code class="xml-style" >
                        <span>Get-Caches -Detail -Server {{this.getFirstPublicIp() ?? this.defaultIp}}</span>
                      </code>
                    </div>

                    <p class="my-2">
                      Now, let's run a "Stress Test" against NCache Cloud server from your workstation. You only need to mention one of the servers in the cache cluster.
                    </p>

                    <div class="code-snippet mb-4 " bg-light>
                      <code class="xml-style" >
                        <span>Test-Stress -CacheName demoCache -Server {{this.getFirstPublicIp() ?? this.defaultIp}}</span>
                      </code>
                    </div>

                    <p class="my-2">
                      Now, click on "Manage" for the Management Center to view performance counters on all the cache servers.
                    </p>
                    <ul>
                      <li>Click "Statistics" for NCache Professional</li>
                      <li>Click "Monitor" for NCache Enterprise</li>
                    </ul>

                    <div class="code-snippet mb-4 " bg-light>
                      <code class="xml-style" >
                        <span>Test-Stress -CacheName demoCache -Server {{this.getFirstPublicIp() ?? this.defaultIp}}</span>
                      </code>
                    </div>

                  </div>
                </div>

              </div>

            </div>

            <div *ngIf="linkType === 'clusterinfo'" class="card">
              <div class="card-body">
                    <h3 class="mb-4">
                      How to create a cluster?
                    </h3>
                    <ul>
                      <li *ngIf="ifPublicIpEnabled()">Launch NCache Management Center by clicking on the "Manage" link on Environment Details page.</li>
                      <li *ngIf="!ifPublicIpEnabled()">Launch NCache Management Center by visiting <span class="tag">{{getIpAndPort()}}</span> <app-clipboard-copy [textToCopy]="getIpAndPort()"/>from a machine which is in a peered VNET.</li>
                      <li>Click "View Details" for demoCache.</li>
                      <li>Click on "Add" in "Server Nodes" area.</li>
                      <li>Specify a private ip-address from the above listed servers.</li>
                      <li>Select demoCache and click "Start" button to start it.</li>
                    </ul>

                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="footer" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="25px">
  <button
    class="btn btn-sm btn-nc btn-outline-primary d-flex"
    (click)="back()">
    Close
  </button>
</div>
